import { TranslatedCall } from "@/components/demos/translated-call"

export function CallDemo() {
  return (
    <section className="page-grid lines-hidden pt-10">
      <TranslatedCall className="col-edge" />
    </section>
  )
}
